export const misReportsRouteDef = [ 
    {
        path: ':resource/misReport',
        component:'ReportDataTableComponent',
        data : {
            selector: 'app-report-data-table',
            action: 'LIST'
        }
    },
    {
        path: 'mis_user_role_mapping',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'mis_user_role_mapping',
            action: 'LIST'
        }
    },
    {
        path: 'mis_user_organization_mapping',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'mis_user_organization_mapping',
            action: 'LIST'
        }
    },
    {
        path: ':resource/misDesign',
        component:'ReportDataTableComponent',
        data : {
            selector: 'app-report-data-table',
            resource: 'billing_reports'
        }
    },
    {
        path: ':resource/misPharmacyDesign',
        component:'ReportDataTableComponent',
        data : {
            selector: 'app-report-data-table',
            resource: 'pharmacy_reports'
        }
    },
    {
        path: ':resource/misInventoryDesign',
        component:'ReportDataTableComponent',
        data : {
            selector: 'app-report-data-table',
            resource: "inventory_reports"
        }
    },
    {
        path: ':resource/misRevenueDesign',
        component:'ReportDataTableComponent',
        data : {
            selector: 'app-report-data-table',
            resource: "revenue_reports"
        }
    },
    // manage_account_users_details
    {
        path: ':foreign_id/user_details',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'manage_account_users_details',
            action: 'LIST',
            foreign_id: 'userId'
        }
    },
    {
        path: ':resource/misDaily',
        component:'ReportDataTableComponent',
        data : {
            selector: 'app-report-data-table',
            resource: "appointment_reports"
        }
    },
    {
        path: ':resource/misopticaldesign',
        component:'ReportDataTableComponent',
        data : {
            selector: 'app-report-data-table',
            resource: 'optical_reports'
        }
    },
    {
        path: ':resource/misTat',
        component:'ReportDataTableComponent',
        data : {
            selector: 'app-report-data-table',
            resource: 'mis_appointment_tat_summary',
            "action": "LIST"
        }
    },
    {
        path: 'mis_discharge_tat',
        component: 'MisDynamicGirdComponent',
        data: {
            selector: 'app-mis-dynamic-gird',
            resource:'mis_discharge_tat',
            action: 'LIST'
        }
    },
    {
        path: ':resource/icmr',
        component: 'DynamicDataGridComponent',
        data: {
            selector: 'app-dynamic-data-grid',
            action: 'LIST'
        }
    },
    {
        path: ':foreign_id/details',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'oltp_to_mis_v2',
            action: 'LIST',
            foreign_id: 'oltp_id'
        }
    },
    {
        path: ':resource/mistemplates',
        component: 'TemplateReportsComponent',
        data: {
            selector: 'app-template-reports',
            resource: 'template_mis',
            action: 'LIST'
        }
    },
    {
        path: ':resource/mistemplates',
        component: 'TemplateReportsComponent',
        data: {
            selector: 'app-template-reports',
            resource: 'health_assessment_mis',
            action: 'LIST'
        }
    },
    {
        path: ':resource/misRadiologyReport',
        component: 'DiagnosticRisReportsComponent',
        data: {
            selector: 'app-diagnostic-ris-reports',
            resource: 'mis_radiology_result_detail_report',
            action: 'LIST'
        }
    },
    {
        path: ':resource/misLaboratoryReport',
        component: 'DiagnosticRisReportsComponent',
        data: {
            selector: 'app-diagnostic-ris-reports',
            resource: 'mis_pathology_template_result_report',
            action: 'LIST'
        }
    },
    {
        path: ':resource/misCardiologyReport',
        component: 'DiagnosticRisReportsComponent',
        data: {
            selector: 'app-diagnostic-ris-reports',
            resource: 'mis_cardiology_result_detail_report',
            action: 'LIST'
        }
    },
    {
        path: ':resource/misPulmonologyReport',
        component: 'DiagnosticRisReportsComponent',
        data: {
            selector: 'app-diagnostic-ris-reports',
            resource: 'mis_pulmonology_result_detail_report',
            action: 'LIST'
        }
    },
    {
        path: ':resource/misNeurologyReport',
        component: 'DiagnosticRisReportsComponent',
        data: {
            selector: 'app-diagnostic-ris-reports',
            resource: 'mis_neurology_result_detail_report',
            action: 'LIST'
        }
    },
    {
        path: ':resource/misNuclearMedicineReport',
        component: 'DiagnosticRisReportsComponent',
        data: {
            selector: 'app-diagnostic-ris-reports',
            resource: 'mis_nuclear_medicine_result_detail_report',
            action: 'LIST'
        }
    },
    {
        path: ':resource/misFeedback',
        component: 'DynamicDataGridComponent',
        data: {
            selector: 'app-dynamic-data-grid',
            action: 'LIST'
        }
    },
]       
